import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import { Quill } from 'react-quill';
var BaseImageFormat = Quill.import('formats/image');
var ImageFormatAttributesList = ['alt', 'width'];

/**
 * A custom block-level Blot for inserting images supported by the RichTextEditor.
 * Designed to extend and support Quill's built-in Image blot.
 *
 * To add to the editor, register this Blot with Quill using the register API.
 *
 * @extends BaseImageFormat
 */
var CustomImage = /*#__PURE__*/function (_BaseImageFormat) {
  _inheritsLoose(CustomImage, _BaseImageFormat);
  function CustomImage() {
    return _BaseImageFormat.apply(this, arguments) || this;
  }
  /**
   * Creates a Image DOM node with src and alt text attributes
   * Uses Quill's Image blot's create function to sanitize the image source url
   *
   * @param {string/object} value - an string or object containing the url and/or the alt text of the image
   * @returns node - the corresponding DOM node for the image
   */
  CustomImage.create = function create(value) {
    var node = _BaseImageFormat.create.call(this, typeof value === 'string' ? value : value.url);
    if (typeof value === 'string' && value === '' || value.url === '') {
      node.setAttribute('src', 'about:blank');
    }
    if (typeof value === 'object') {
      node.setAttribute('alt', value.alt);
    }
    return node;
  }

  /**
   * Returns the format values represented by domNode if it is this Blot's type,
   * no check that domNode is this Blot's type is required
   *
   * @param {Node} domNode - The domNode representing the blot
   * @returns the format values represented by the domNode
   */;
  CustomImage.formats = function formats(domNode) {
    return ImageFormatAttributesList.reduce(function (formats, attribute) {
      if (domNode.hasAttribute(attribute)) {
        formats[attribute] = domNode.getAttribute(attribute);
      }
      return formats;
    }, {});
  }

  /**
   * Apply format to blot. Should not pass onto child or another blot
   * If value is null, the name attribute is removed from the blot
   *
   * @param {String} name - Name of the format
   * @param {Any} value - Value of the format
   */;
  var _proto = CustomImage.prototype;
  _proto.format = function format(name, value) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, value);
      } else {
        this.domNode.removeAttribute(name);
      }
    } else {
      _BaseImageFormat.prototype.format.call(this, name, value);
    }
  };
  return CustomImage;
}(BaseImageFormat);
CustomImage.blotName = 'image';
CustomImage.tagName = 'img';
export default CustomImage;